(() => {
  window.eviLavaLampVersion = "2026-09-17-scroll-fix-v2";

  const blob = document.getElementById("tabs-lava-lamp-blob");
  const track = document.querySelector(".tabs-lava-lamp");
  const navItems = document.querySelectorAll(".tabs-lava-lamp li");

  let activeItem = document.querySelector(".tabs-lava-lamp .active");
  let isScrolling = false;
  let scrollTimeout = null;

  if (!blob || !track || navItems.length === 0) return;

  const sectionToTabMap = {
    description: "description",
    specs_long: "specs_long",
    instructions: "instructions",
    "media-section": "all-features",
    "description-grid-section": "all-features",
    "image-with-text-section": "all-features",
    "about-evi": "about-evi",
    "service-vorteile": "about-evi",
    "testimonials-quote": "testimonials-quote",
  };

  const getScrollOffset = () => {
    const root = document.documentElement;
    const headerHeight =
      Number.parseInt(
        getComputedStyle(root).getPropertyValue("--header-height"),
      ) || 0;
    const breadcrumbsHeight =
      Number.parseInt(
        getComputedStyle(root).getPropertyValue("--breadcrumbs-height"),
      ) || 0;

    return headerHeight + breadcrumbsHeight;
  };

  const scrollToElement = (element) => {
    if (!element) return;

    const offset = getScrollOffset();
    const offsetPosition =
      element.getBoundingClientRect().top + window.pageYOffset - offset;

    isScrolling = true;

    if (scrollTimeout) clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      isScrolling = false;
      window.dispatchEvent(new Event("scroll"));
    }, 1000);

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const makeBlob = () => {
    if (!activeItem) return;

    blob.style.width = `${activeItem.clientWidth}px`;
    blob.style.height = `${activeItem.clientHeight}px`;
    blob.style.left = `${activeItem.offsetLeft}px`;
    blob.style.top = `${activeItem.offsetTop}px`;
    blob.classList.add("blob-initialized");
  };

  const animate = (target) => {
    if (!target) return;

    navItems.forEach((item) => item.classList.remove("active-hover"));

    const animation = blob.animate(
      [
        {
          left: `${blob.offsetLeft}px`,
          width: `${blob.clientWidth}px`,
        },
        {
          left: `${target.offsetLeft}px`,
          width: `${target.clientWidth}px`,
        },
      ],
      {
        duration: 300,
        easing: "cubic-bezier(0.87, 0, 0.13, 1)",
        fill: "forwards",
      },
    );

    animation.addEventListener("finish", () => {
      blob.style.left = `${target.offsetLeft}px`;
      blob.style.width = `${target.clientWidth}px`;
      animation.cancel();
    });

    target.classList.add("active-hover");
  };

  const scrollIntoView = (element) => {
    const container =
      element?.closest(".product__info-navigations--container") ||
      element?.closest(".popular-products__collection-tabs-list--wrapper");

    if (!container || !element) return;

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    if (elementRect.left < containerRect.left) {
      const scrollAmount = elementRect.left - containerRect.left;

      if (container.scrollLeft + scrollAmount < 50) {
        container.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    } else if (elementRect.right > containerRect.right) {
      const scrollAmount = elementRect.right - containerRect.right;
      const newScrollLeft = container.scrollLeft + scrollAmount;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (maxScrollLeft - newScrollLeft < 50) {
        container.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  const setActive = (item) => {
    if (!item || item.id === "tabs-lava-lamp-blob") return;

    navItems.forEach((navItem) => {
      if (navItem.id === "tabs-lava-lamp-blob") return;

      navItem.classList.remove("active");
      navItem.setAttribute("aria-selected", "false");
      navItem.setAttribute("tabindex", "-1");
    });

    item.classList.add("active");
    item.setAttribute("aria-selected", "true");
    item.setAttribute("tabindex", "0");
    activeItem = item;

    animate(item);
    scrollIntoView(item);
  };

  const observeHorizontalScroll = (className = "") => {
    const element = document.querySelector(className);

    if (!element) return;

    const checkScrollState = () => {
      const scrollLeft = element.scrollLeft;
      const maxScrollLeft = element.scrollWidth - element.clientWidth;
      const hasScroll = element.scrollWidth > element.clientWidth;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScrollLeft - 2;

      if (hasScroll && !atStart) {
        element.classList.add("left-shadow");
      } else {
        element.classList.remove("left-shadow");
      }

      if (hasScroll && !atEnd) {
        element.classList.add("right-shadow");
      } else {
        element.classList.remove("right-shadow");
      }
    };

    element.addEventListener("scroll", checkScrollState, { passive: true });
    new ResizeObserver(checkScrollState).observe(element);
    checkScrollState();
  };

  const init = () => {
    observeHorizontalScroll(".product__info-navigations--container");
    observeHorizontalScroll(
      ".popular-products__collection-tabs-list--wrapper",
    );

    makeBlob();

    track.addEventListener("click", (event) => {
      const item = event.target.closest("li");

      if (!item || item.id === "tabs-lava-lamp-blob") return;

      const targetId = item
        .querySelector("a")
        ?.getAttribute("href")
        ?.replace("#", "");

      event.preventDefault();

      if (targetId === "all-features") {
        const firstFeaturesSectionId = Object.keys(sectionToTabMap).find(
          (key) => sectionToTabMap[key] === "all-features",
        );

        scrollToElement(document.getElementById(firstFeaturesSectionId));
      } else {
        scrollToElement(document.getElementById(targetId));
      }

      setActive(item);
    });

    if (window.innerWidth > 767) {
      track.addEventListener("mouseover", (event) => {
        const item = event.target.closest("li");

        if (!item || item.id === "tabs-lava-lamp-blob") return;
        animate(item);
      });

      track.addEventListener("mouseout", () => {
        navItems.forEach((item) => item.classList.remove("active-hover"));
        animate(activeItem);
      });
    }

    const getDocumentTop = (element) =>
      element.getBoundingClientRect().top + window.scrollY;

    const trackedSections = Object.keys(sectionToTabMap)
      .map((id) => document.getElementById(id))
      .filter(Boolean)
      .sort((first, second) => getDocumentTop(first) - getDocumentTop(second));

    let scrollFrame = null;

    const updateActiveFromScroll = () => {
      scrollFrame = null;

      if (isScrolling || trackedSections.length === 0) return;

      const activationLine =
        window.scrollY +
        getScrollOffset() +
        Math.min(window.innerHeight * 0.28, 240);

      let currentSection = trackedSections[0];

      trackedSections.forEach((section) => {
        if (getDocumentTop(section) <= activationLine) {
          currentSection = section;
        }
      });

      const tabId = sectionToTabMap[currentSection.id];
      if (!tabId) return;

      const item = document
        .querySelector(`.tabs-lava-lamp a[href="#${tabId}"]`)
        ?.closest("li");

      if (item && item !== activeItem) setActive(item);
    };

    const requestScrollUpdate = () => {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(updateActiveFromScroll);
    };

    window.addEventListener("scroll", requestScrollUpdate, { passive: true });
    window.addEventListener("resize", () => {
      makeBlob();
      requestScrollUpdate();
    });

    requestScrollUpdate();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
